import { MarketType, useBuyersProfileQuery } from 'generated/graphql';

export const isCatalogMarketType = (marketType?: MarketType | null) =>
  marketType === MarketType.Catalog || marketType === MarketType.Both;

export const isDefaultMarketType = (marketType?: MarketType | null) =>
  marketType === MarketType.Default || marketType === MarketType.Both;

const useBuyerMarketType = (profileID?: string) => {
  const [result] = useBuyersProfileQuery({
    variables: { profileID: profileID ?? '' },
    pause: !profileID,
  });

  const marketType = result.data?.buyersProfile.marketType;

  return {
    marketType,
    isCatalogBuyer: isCatalogMarketType(marketType),
    isDefaultMarketBuyer: isDefaultMarketType(marketType),
    fetching: result.fetching,
  };
};

export default useBuyerMarketType;
